import { createTheme } from '@material-ui/core/styles';
import { ZIndex } from '@material-ui/core/styles/zIndex';
import { ThemeOptions } from '@material-ui/core/styles';
import { sharedTypography } from '../sharedTypography';
import { defaultThemeProps } from '../defaultThemeProps';

declare module '@material-ui/core/styles/zIndex' {
  interface ZIndex {
    negative: number;
  }
}

declare module '@material-ui/core/styles' {
  interface Theme {
    zIndex: ZIndex;
  }

  interface ThemeOptions {
    custom?: any;
  }
}

export const createLemonadeTheme = (options: ThemeOptions = {}) => {
  return createTheme(options);
};

const themeOptions = {
  colors: {
    primary: '#000000',
    white: '#FFFFFF',
    secondary: '#3A39BB',
    primaryText: '#636363',
    secondaryText: '#363636',
    metamask: '#FF8F44',
    midGray: '#707070',
    error: '#BD3939',
    midBlack: '#333333',
    activeInfo: '#5375F6',
    placeholder: '#7F7F7F',
    bgGray: '#F9F9F9',
    purp: '#0C85F4',
    success: '#3CA118',
    error1: '#C83C5D',
    borderGrey: '#D2D2D2',
    iconHighLight: '#F0F0F0',
    purple: '#0C85F4',
    grey1: '#C4C4C4',
    disabledText: '#ACACAC',
    lightGray: '#F0F0F0',
    borderTable: '#D9D9D9',
    purpleOpacity50: '#0C85F450',
  },
  fontSize: {
    h1: '57.33px',
    h2: '47.78px',
    h3: '39.81px',
    h4: '33.18px',
    h5: '27.65px',
    h6: '18px',
    size16: '16px',
  },
  fontFamily: {
    bold: 'Montserrat-Bold',
    regular: 'Montserrat',
    title: 'Montserrat',
  },
  bodyText: {
    large: '19.2px',
    regular: '16px',
    small: '13.33px',
    extraSmall: '11.11px',
  },
  width: {
    leftLayout: '92px',
  },
  font: {
    label: 'normal normal 400 16px/24px Montserrat',
    placeholder: 'normal normal 400 13.33px/16px Montserrat',
    contentText: 'normal normal 400 14px/24px Montserrat',
    text12: 'normal normal 400 12px/16px Montserrat',

    montserrat25: 'normal normal 700 25px/40px Montserrat',
    montserrat13: 'normal normal 600 13.33px/16px Montserrat',
    montserrat18: 'normal normal 700 18px/32px Montserrat',
    montserrat1: 'normal normal 600 1px/1px Montserrat',
    montserrat24Bold: 'normal normal 700 25px/40px Montserrat-Bold',

    montserrat16Bold: 'normal normal 700 16px/24px Montserrat-Bold',
    montserrat14Bold: 'normal normal 700 14px/16px Montserrat-Bold',
    montserrat12Bold: 'normal normal 700 12px/10px Montserrat-Bold',
    montserrat12: 'normal normal 400 12px/10px Montserrat',
    montserrat14: 'normal normal 400 14px/16px Montserrat',
    montserrat16: 'normal normal 400 16px/24px Montserrat',
    priceSymbol: 'normal normal 400 11px/16px Montserrat',
    montserrat32: 'normal normal 400 32px/16px Montserrat',

    paragraph: 'normal normal 400 14px/16px Montserrat',
    paragraph2: 'normal normal 400 14px/16px Montserrat',
    paragraph3: 'normal normal 400 16px/24px Montserrat',
    paragraphMontserrat: 'normal normal 400 14px/18px Montserrat',

    heading1: 'normal normal 700 24px/16px Montserrat',
    heading1Mont: 'normal normal 700 24px/16px Montserrat-Bold',
    heading2: 'normal normal 700 19.2px/22px Montserrat-Bold',
    heading3: 'normal normal 700 16px/16px Montserrat-Bold',
    heading6: 'normal normal 700 18px/24px Montserrat',


    heading1Editor: 'normal normal 700 24px/30px Montserrat-Bold',
    heading2Editor: 'normal normal 700 19.2px/24px Montserrat-Bold',
    heading3Editor: 'normal normal 700 16px/18px Montserrat-Bold',

    montserratLink: 'normal normal 700 14px/18px Montserrat',
    headingMontserrat1: 'normal normal 700 24px/16px Montserrat',
    headingMontserrat3: 'normal normal 700 16px/16px Montserrat',

    h3: 'normal normal 700 16px/16px Montserrat',
    h6: 'normal normal 700 18px/24px Montserrat',

    tabsTilte: '700 24px/30px "Montserrat"',
  },
};

const defaultTheme = createLemonadeTheme({
  custom: themeOptions,
  typography: sharedTypography(),
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '@font-face': [{ fontFamily: 'Montserrat' }],
      },
    },
  },
  palette: {
    text: {
      primary: 'rgba(0, 0, 0)',
    }
  },
});

if (defaultTheme.props) {
  defaultTheme.props = defaultThemeProps(defaultTheme.props);
}

export { themeOptions };
export default defaultTheme;
